export default () => {
  if(document.querySelector('.clients-item-link') && window.innerWidth > 1024){
    let timeoutId = null;
    const BLUR_DELAY = 2000;
    const UNBLUR_DELAY = 200;
    document.addEventListener('mouseover', (e)=>{
      if(e.target.closest('.clients-item-link')) {
        let items = document.querySelectorAll('.clients-item-link'),
        thisItem = e.target.closest('.clients-item-link');
        timeoutId = window.setTimeout(function(){
            items.forEach(item=>{
                if(item != thisItem){
                    item.querySelector('.img-wrapper').classList.add('blurred');
                } else {
                    item.querySelector('.img-wrapper').classList.remove('blurred');
                }
                });
            }, BLUR_DELAY);
        }
    });

    document.addEventListener('mouseout', (e)=>{
      if(e.target.closest('.clients-item-link') || e.target.closest('.clients')) {
        let items = document.querySelectorAll('.clients-item-link');
        window.clearTimeout(timeoutId)
        items.forEach(item=>{
            setTimeout(() => {
                item.querySelector('.img-wrapper').classList.remove('blurred');
            }, UNBLUR_DELAY);
          
        });
       
      } 
    })
  }
}